import { WishlistButton as WishlistButtonBase } from "@omni/components/components/Navigation/Buttons/WishlistButton/wishlistButton";
import { WishlistButtonProps } from "@omni/types/components/props/wishlistButton.props";
import { BaseStore } from "@omni/types/enums/baseStore.enum";

import { WishlistButtonComponent } from "@/components/Navigation/Buttons/WishlistButton/wishlistButton.component";

export const WishlistButton = ({
    // HeaderButton props
    text,
    ariaLabel,
    hiddenText,
    icon,
    link,
    invert,
    invertMobile,
    showMenuOnHover
}: WishlistButtonProps<BaseStore.Etna>) => {
    return (
        <WishlistButtonBase
            text={text}
            ariaLabel={ariaLabel}
            hiddenText={hiddenText}
            icon={icon}
            link={link}
            invert={invert}
            invertMobile={invertMobile}
            showMenuOnHover={showMenuOnHover}
        >
            <WishlistButtonComponent />
        </WishlistButtonBase>
    );
};
